import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { setAutomationElement } from '@experian-uk/corvetteuk-common-ui';
import selectOffer from '../../../actions/offers/select';
import updateSession from '../../../actions/session/update';
import syncSession from '../../../actions/session/sync';
import { BreachPlusCancelInfoContainer, TextButton } from './index.styles';
import { clickInteractionECD } from '../../../pages/home/homePageEcd2';
import { CancelInfoText } from '../BreachDeactivateInfo/index.styles';

const BreachPlusCancelInfo = ({ offer }) => {
  const dispatch = useDispatch();

  const goToSwitch = async e => {
    e.preventDefault();
    const productOptionOfferId = offer.id;
    const productOptionFamily = offer.family;

    const ECDComponentName = 'free_account_card_cancel_account';

    clickInteractionECD(ECDComponentName);

    dispatch(selectOffer(productOptionOfferId, productOptionFamily));

    dispatch(
      updateSession({
        selectedOfferId: productOptionOfferId,
        selectedOfferFamily: productOptionFamily,
      })
    );
    dispatch(syncSession());

    dispatch(push('/switch'));
  };

  return (
    <BreachPlusCancelInfoContainer>
      <CancelInfoText>Your free account can be cancelled if you no longer need it.</CancelInfoText>
      <TextButton {...setAutomationElement('panel-button')} onClick={goToSwitch}>
        Cancel my account
      </TextButton>
    </BreachPlusCancelInfoContainer>
  );
};

BreachPlusCancelInfo.propTypes = {
  offer: PropTypes.shape({
    id: PropTypes.string.isRequired,
    family: PropTypes.string.isRequired,
  }).isRequired,
};

export default BreachPlusCancelInfo;
